import React, { useState } from 'react';
import SVG_ChevronDownIcon from '../../assets/images/svgs/chevronDown.svg?react';

const Accordion = ({item}) => {
    const [open, setOpen] = useState(false);

    return (
        <article>
            <div 
                className="w-full bg-bg_Quaternary rounded-md flex items-center justify-center"
                onClick={() => {setOpen(!open);}}
            >
                <h1 className="text-md p-[12px] font-normal text-white w-full bg-bg_Quaternary flex items-center justify-between rounded-sm cursor-pointer">
                    <span className="font-lato text-[14px]">{item?.title}</span>
                    <span className={`flex items-center ml-[8px] autoAnimate ${open? 'rotate-0' : '-rotate-180'}`}>
                        <SVG_ChevronDownIcon fill="var(--color-ternary)" />
                    </span>
                </h1>
            </div>

            <div
                className={` transition-all duration-300 w-full bg-bg_Quaternary  rounded-sm flex flex-col  ${open? 'max-h-[240px] opacity-100 overflow-y-auto mt-[2px]' : 'overflow-hidden max-h-0 opacity-0'}`}
                style={{visibility: open? 'visible' : 'hidden'}}
            >
                {item?.content}
            </div>
        </article>
    )
}

export default Accordion;